var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "file-browser" },
    [
      _c(
        "div",
        {
          staticClass: "file-table-header file-table-grid",
          on: {
            contextmenu: function($event) {
              $event.stopPropagation()
              $event.preventDefault()
              return _vm.$refs.FileSystem.showContextMenu($event, null)
            }
          }
        },
        [
          _c(
            "button",
            {
              staticClass: "file-table-heading",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.sort("name")
                }
              }
            },
            [
              _c("span", [_vm._v("Name")]),
              _vm.sortBy === "name"
                ? _c("portal-icon", {
                    attrs: {
                      name:
                        _vm.sortDir === "asc" ? "chevron-up" : "chevron-down",
                      size: 14
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "button",
            {
              staticClass: "file-table-heading file-col-modified",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.sort("updated")
                }
              }
            },
            [
              _c("span", [_vm._v("Modified")]),
              _vm.sortBy === "updated"
                ? _c("portal-icon", {
                    attrs: {
                      name:
                        _vm.sortDir === "asc" ? "chevron-up" : "chevron-down",
                      size: 14
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "button",
            {
              staticClass: "file-table-heading file-col-size",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.sort("size")
                }
              }
            },
            [
              _c("span", [_vm._v("Size")]),
              _vm.sortBy === "size"
                ? _c("portal-icon", {
                    attrs: {
                      name:
                        _vm.sortDir === "asc" ? "chevron-up" : "chevron-down",
                      size: 14
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c("div", { staticClass: "file-table-heading file-col-version" }, [
            _vm._v("Ver")
          ]),
          _c("div")
        ]
      ),
      _c("file-system", {
        ref: "FileSystem",
        attrs: {
          "sort-by": _vm.sortBy,
          "sort-dir": _vm.sortDir,
          "parent-folder-id": _vm.folderId,
          "show-deleted": _vm.showDeleted,
          "parent-deleted": false,
          depth: 0,
          "is-dragging": _vm.isDragging,
          "read-only": _vm.readOnly,
          "allow-upload": _vm.allowUpload
        }
      }),
      !_vm.readOnly || _vm.allowUpload
        ? _c("div", { staticClass: "file-browser-footer" }, [
            _c(
              "button",
              {
                staticClass: "file-upload-action",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.$refs.FileSystem.handleUploadFile()
                  }
                }
              },
              [
                _c("portal-icon", { attrs: { name: "upload", size: 16 } }),
                _c("span", [_vm._v("Upload file")])
              ],
              1
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }